import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MediaMatcher } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

import { UiService } from './shared/services/ui.service';
import { AuthService } from './shared/services/auth.service';
import { AppConfigService } from './shared/services/app-config.service';
import { LanguageService } from './shared/services/language.service';
import { AuthUser } from '@classes/auth/auth-user';
import { Router, NavigationStart } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    private rLoadingSub: Subscription;
    private tLoadingSub: Subscription;
    private authSub: Subscription;
    private userSub: Subscription;

    isAuth: boolean;
    user: AuthUser;
    isMaintenance: boolean;
    isError: boolean;
    isRouteLoading: boolean;
    isTranslationLoading: boolean;

    mode: string;
    isOpen: true;
    mobileQuery: MediaQueryList;
    isStandalone: boolean;

    private _mobileQueryListener: () => void;

    constructor(
        private configSrv: AppConfigService,
        private uiSrv: UiService,
        private authSrv: AuthService,
        private changeDetectorRef: ChangeDetectorRef,
        private media: MediaMatcher,
        private langSrv: LanguageService,
        private router: Router,
        private httpClient: HttpClient
    ) {
        this.mode = "side";
        this.mobileQuery = media.matchMedia('(max-width: 999px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);
        this.isMaintenance = configSrv.isMaintenance;
    }

    ngOnInit() {
        this.ClearCacheIfNewVersion();

        this.isAuth = this.authSrv.isAuth();

        this.initSubscriptions();

        if(this.authSrv.getDecodedToken()) {
            this.langSrv.setCurrentLanguage('');

            if(this.isMaintenance) {
                this.authSrv.logout();
            }
        }
    }

    toggleSidenav(sidenav: MatSidenav, isToggle?: boolean): void {
        if(isToggle) {
            sidenav.toggle();
        } else if(this.mobileQuery.matches) {
            sidenav.close();
        }
    }

    private initSubscriptions(): void {
        this.rLoadingSub = this.uiSrv.routeLoadingStateChanged
        .subscribe(loadingState => {
            this.isRouteLoading = loadingState;
        });

        this.tLoadingSub = this.uiSrv.translationLoadingStateChanged
        .subscribe(loadingState => {
            this.isTranslationLoading = loadingState;
        });

        this.authSub = this.authSrv.authChanged
        .subscribe(authStatus => {
            this.isAuth = authStatus;
        });

        this.userSub = this.authSrv.authUserChanged
        .subscribe(authUser => {
            this.user = authUser;
        });

        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationStart) {
                this.isStandalone = event.url.includes('/wiki') || event.url.includes('/helpdesk');
            }
        });
    }

    ngOnDestroy() {
        if(this.rLoadingSub) {
            this.rLoadingSub.unsubscribe();
        }
        if(this.tLoadingSub) {
            this.tLoadingSub.unsubscribe();
        }
        if(this.authSub) {
            this.authSub.unsubscribe();
        }
        if(this.userSub) {
            this.userSub.unsubscribe();
        }

        this.mobileQuery.removeListener(this._mobileQueryListener);
    }

    private ClearCacheIfNewVersion(): void
    {
        const newBuild = `${environment.version}.${environment.build}`;
        const oldBuild = localStorage.getItem('build');
        if (newBuild !== oldBuild)
        {
            localStorage.setItem('build', newBuild);

            const headers = new HttpHeaders()
                .set('Cache-Control', 'no-cache')
                .set('Pragma', 'no-cache');

            this.httpClient
                .get("", { headers, responseType: "text" })
                .subscribe(() => location.reload());
        }
    }
}
